document.addEventListener('DOMContentLoaded', function () {
  const totalEl = document.querySelector('[data-vap-cart-total]');
  const countEls = document.querySelectorAll('[data-vap-cart-count]');
  const itemsWrap = document.querySelector('[data-cart-hover-items]');
  const hoverWrap = document.querySelector('.vap-cart-hover-wrap');
  const hoverPanel = document.querySelector('.vap-cart-hover');

  function formatMoney(cents) {
    return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (m) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[m];
    });
  }

  function renderItems(cart) {
    if (!itemsWrap) return;

    if (!Array.isArray(cart.items) || cart.items.length === 0) {
      itemsWrap.innerHTML = `
        <div class="vap-mini-empty">
          Votre panier est vide
        </div>
      `;
      return;
    }

    itemsWrap.innerHTML = cart.items.slice(0, 3).map(function (item) {
      const image = item.image
        ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')
        : '';

      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="vap-mini-variant">${escapeHtml(item.variant_title)}</div>`
        : '';

      return `
        <div class="vap-mini-item">
          ${
            image
              ? `<img src="${image}" class="vap-mini-img" alt="${escapeHtml(item.product_title || item.title || '')}">`
              : `<div class="vap-mini-img"></div>`
          }

          <div class="vap-mini-info">
            <div class="vap-mini-title">${escapeHtml(item.product_title || item.title || '')}</div>
            ${variant}
            <div class="vap-mini-price">x${item.quantity} · ${formatMoney(item.final_line_price)}</div>
          </div>

          <a
            href="${item.url_to_remove || '#'}"
            class="vap-mini-remove"
            aria-label="Supprimer ${escapeHtml(item.product_title || item.title || '')}"
          >
            ×
          </a>
        </div>
      `;
    }).join('');
  }

  function pulseMiniCart() {
    if (!hoverPanel) return;

    hoverPanel.classList.remove('vap-cart-panel-bump');
    void hoverPanel.offsetWidth;
    hoverPanel.classList.add('vap-cart-panel-bump');

    setTimeout(function () {
      hoverPanel.classList.remove('vap-cart-panel-bump');
    }, 520);
  }

  function pulseBadge() {
    if (!countEls.length) return;

    countEls.forEach(function (countEl) {
      countEl.classList.remove('vap-cart-badge-pop');
      void countEl.offsetWidth;
      countEl.classList.add('vap-cart-badge-pop');

      setTimeout(function () {
        countEl.classList.remove('vap-cart-badge-pop');
      }, 420);
    });
  }

  async function refreshVapCartUi(animate) {
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) return;

      const cart = await response.json();

      if (totalEl) {
        totalEl.textContent = formatMoney(cart.total_price);
      }

      countEls.forEach(function (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = 'inline-flex';
      });

      const footerTotal = document.querySelector('[data-cart-hover-total]');
      if (footerTotal) {
        footerTotal.textContent = formatMoney(cart.total_price);
      }

      renderItems(cart);

      if (animate && hoverWrap) {
        hoverWrap.classList.add('vap-cart-force-open');
        pulseMiniCart();
        pulseBadge();

        setTimeout(function () {
          hoverWrap.classList.remove('vap-cart-force-open');
        }, 1800);
      }
    } catch (e) {}
  }

  if (hoverWrap) {
    hoverWrap.addEventListener('mouseenter', function () {
      refreshVapCartUi(false);
    });
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form && form.action && form.action.includes('/cart/add')) {
      setTimeout(function () {
        refreshVapCartUi(true);
      }, 550);
    }
  }, true);

  document.addEventListener('cart:updated', function () {
    setTimeout(function () {
      refreshVapCartUi(true);
    }, 120);
  });

  document.addEventListener('cart:refresh', function () {
    setTimeout(function () {
      refreshVapCartUi(true);
    }, 120);
  });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-vh-chat]');
    if (!btn) return;

    e.preventDefault();

    if (window.ShopifyInbox && typeof window.ShopifyInbox.open === 'function') {
      window.ShopifyInbox.open();
    } else if (window.$shopifyInbox && typeof window.$shopifyInbox.toggle === 'function') {
      window.$shopifyInbox.toggle();
    } else {
      window.location.href = '/pages/contact';
    }
  });

  const searchToggle = document.querySelector('.vh-search-icon');
  const searchBox = document.querySelector('.vh-search');

  if (searchToggle && searchBox) {
    searchToggle.addEventListener('click', function (e) {
      if (window.innerWidth > 989) return;

      e.preventDefault();
      searchBox.classList.toggle('vh-search-open');

      const input = searchBox.querySelector('input');
      if (searchBox.classList.contains('vh-search-open') && input) {
        setTimeout(function () {
          input.focus();
        }, 50);
      }
    });
  }

  function forceMobileMenuLabels() {
    const menuLinks = document.querySelectorAll('.vh-menu a');

    menuLinks.forEach(function (link) {
      const txt = (link.textContent || '').trim().toUpperCase();

      if (
        txt === 'CIGARETTE ELECTRONIQUE' ||
        txt === 'CIGARETTE ÉLECTRONIQUE' ||
        txt === 'E-CIGARETTES'
      ) {
        link.textContent = 'E-CIGARETTE';
      }
    });
  }

  forceMobileMenuLabels();
  setTimeout(forceMobileMenuLabels, 300);
  setTimeout(forceMobileMenuLabels, 1000);
  setTimeout(forceMobileMenuLabels, 2000);

  const menu = document.querySelector('.vh-menu');
  if (menu) {
    const observer = new MutationObserver(function () {
      forceMobileMenuLabels();
    });

    observer.observe(menu, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  const burgerBtn = document.querySelector('.vh-burger');
  const burgerDrawer = document.querySelector('.vh-burger-drawer');
  const burgerOverlay = document.querySelector('.vh-burger-overlay');
  const burgerClose = document.querySelector('.vh-burger-close');

  if (burgerBtn && burgerDrawer && burgerOverlay && burgerClose) {
    function openBurger() {
      document.body.classList.add('vh-burger-open');
    }

    function closeBurger() {
      document.body.classList.remove('vh-burger-open');
    }

    burgerBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openBurger();
    });

    burgerClose.addEventListener('click', function (e) {
      e.preventDefault();
      closeBurger();
    });

    burgerOverlay.addEventListener('click', closeBurger);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeBurger();
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const desktopMenuLinks = document.querySelectorAll('.vh-menu-item > .vh-menu-link');

  desktopMenuLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      if (window.innerWidth > 989) {
        e.preventDefault();
      }
    });
  });
});



